import { Offcanvas, Container, Row, Col } from 'react-bootstrap';
import { ShopStyled } from '../shopSetting/assets/shopStyled';
import StyledText from '../../app/components/styledComponents/StyledText';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { useGetRegionalSettingsQuery } from '../shopSetting/shopAPISlice';
import { useGetCustomerEmailReminderListQuery } from './customersApiSlice';
import StyledLoading from '../../app/components/loading/StyledLoading';
import { useEffect } from 'react';

const StyledOffCanvasBody = styled(Offcanvas.Body)`
  background-color: ${({ theme }) => theme.primaryLight2};
`;

const StyledTag = styled.div`
  background-color: ${({ theme }) => theme.primaryLight2};
  // border: 2px solid ${({ theme }) => theme.primary};
  border-radius: 10px;
  color: ${({ theme }) => theme.primary};
  display: inline-block;
  padding: 0 10px;
`;

const CustomerReminder = ({ show, onHide, customer }) => {
  const { data: regionalSettings } = useGetRegionalSettingsQuery();
  const timeZoneString =
    regionalSettings && regionalSettings?.timezone
      ? regionalSettings?.timezone?.match(/\(([^)]+)\)$/)?.[1]
      : '';

  const { data: reminderList, isFetching: reminderFetching , refetch } =
    useGetCustomerEmailReminderListQuery(customer?.id);

    useEffect(() => {
      refetch();
    } , [])

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement={'end'}
      style={{
        minWidth: 550,
      }}
    >
      <Offcanvas.Header closeButton className="bg-white px-4">
        <Offcanvas.Title>
          <ShopStyled.PageTitle className="m-0">
            Reminder Details
          </ShopStyled.PageTitle>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <StyledOffCanvasBody>
        <Container className="h-100">
          {reminderFetching ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center">
              <StyledLoading />
            </div>
          ) : (
            <>
              {!reminderList?.objectData?.reminders ||
              reminderList?.objectData?.reminders?.length <= 0 ? (
                <div className="h-100 w-100 d-flex align-items-center justify-content-center">
                  <StyledText
                    as={'p'}
                    color={'bodyMedium'}
                    $fontSize={'28px'}
                    $fontWeight={'500'}
                    className="text-center"
                  >
                    No Data Found
                  </StyledText>
                </div>
              ) : (
                <>
                  {reminderList?.objectData?.reminders?.map((item) => (
                    <ShopStyled.BootstrapCard className="px-3 py-4 bg-white">
                      <Row>
                        <Col>
                          <StyledText
                            as={'p'}
                            color={'headingColor'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                          >
                            Occasion
                          </StyledText>
                        </Col>
                        <Col className="ps-0">
                          {}
                          <StyledText
                            as={'p'}
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            className="text-end"
                          >
                            {item?.occasion ?? '-'}
                          </StyledText>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <StyledText
                            as={'p'}
                            color={'headingColor'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                          >
                            Reminder Date
                          </StyledText>
                        </Col>
                        <Col className="ps-0">
                          {}
                          <StyledText
                            as={'p'}
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            className="text-end"
                          >
                            {item?.date
                              ? moment
                                  ?.utc(item.date)
                                  ?.tz(timeZoneString ?? moment?.tz?.guess())
                                  ?.format('MMM Do, YYYY')
                              : '-'}
                            {item?.date ?? '-'}
                          </StyledText>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <StyledText
                            as={'p'}
                            color={'headingColor'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                          >
                            Repeat
                          </StyledText>
                        </Col>
                        <Col className="ps-0">
                          <StyledText
                            as={'p'}
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            className="text-end"
                          >
                            {item?.repeat ?? '-'}
                          </StyledText>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <StyledText
                            as={'p'}
                            color={'headingColor'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                          >
                            Reminder Days Before
                          </StyledText>
                        </Col>
                        <Col className="ps-0">
                          {}
                          <StyledText
                            as={'p'}
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            className="text-end"
                          >
                            {item?.daysBefore !== undefined &&
                            item?.daysBefore !== null
                              ? item?.daysBefore == 0
                                ? 'Same day'
                                : item?.daysBefore
                              : '-'}
                          </StyledText>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <StyledText
                            as={'p'}
                            color={'headingColor'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                          >
                            Email
                          </StyledText>
                        </Col>
                        <Col className="ps-0">
                          {}
                          <StyledText
                            as={'p'}
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            className="text-end"
                          >
                            {item?.email ?? '-'}
                          </StyledText>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <StyledText
                            as={'p'}
                            color={'headingColor'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                          >
                            Reminder Message
                          </StyledText>
                        </Col>
                        <Col className="ps-0">
                          {}
                          <StyledText
                            as={'p'}
                            color={'bodyMedium'}
                            $fontSize={'18px'}
                            $fontWeight={'500'}
                            className="text-end"
                          >
                            {item?.reminderName ?? '-'}
                          </StyledText>
                        </Col>
                      </Row>

                      {/* <Row className="py-2 border-bottom">
                <StyledText
                  as={'div'}
                  color={'headingColor'}
                  $fontSize={'22px'}
                  $fontWeight={'500'}
                  className="d-flex gap-2 align-items-center"
                >
                  <p className="m-0">Cart Summary</p>
                  <StyledTag>
                    <p className="m-0">
                      {order.customerCartDetailsDTOS?.length
                        ? `${order.customerCartDetailsDTOS?.length} ${
                            order.customerCartDetailsDTOS?.length === 1
                              ? 'Item'
                              : 'Items'
                          }`
                        : 'No Items'}
                    </p>
                  </StyledTag>
                </StyledText>
              </Row> */}

                      {/* <Row className="ps-2 py-2 border-bottom">
                {order.customerCartDetailsDTOS?.length ? (
                  <ul className="list-unstyled m-0">
                    {order.customerCartDetailsDTOS?.map((product, index) => (
                      <li key={index}>
                        <div className="d-flex justify-content-between">
                          <div className="d-flex gap-1 w-75">
                            <StyledText
                              as={'p'}
                              color={'bodyMedium'}
                              $fontSize={'16px'}
                              $fontWeight={'500'}
                            >
                              {product.quantity}
                            </StyledText>
                            <StyledText
                              as={'p'}
                              color={'bodyMedium'}
                              $fontSize={'16px'}
                              $fontWeight={'500'}
                            >
                              x
                            </StyledText>
                            <StyledText
                              as={'p'}
                              color={'bodyMedium'}
                              $fontSize={'16px'}
                              $fontWeight={'500'}
                            >
                              {`${
                                product.floristInventoryDTO?.itemName ??
                                product.floristAddonsDto?.title ??
                                ''
                              }${
                                product.variationDTO?.title
                                  ? ` - ${product.variationDTO.title}`
                                  : ''
                              }`}
                              {product.floristAddonsDto?.selectedVariation &&
                                ` - ${product.floristAddonsDto?.selectedVariation?.title}`}
                            </StyledText>
                          </div>
                          <div className="d-flex justify-content-end align-item-center gap-2 w-25">
                            <StyledText
                              as={'p'}
                              color={'bodyMedium'}
                              $fontSize={'16px'}
                              $fontWeight={'500'}
                            >
                              ${product.unitPrice?.toFixed(2)}
                            </StyledText>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: 150 }}
                  >
                    <StyledText
                      as={'p'}
                      color={'bodyMedium'}
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                    >
                      Cart is empty
                    </StyledText>
                  </div>
                )}
              </Row> */}
                    </ShopStyled.BootstrapCard>
                  ))}
                </>
              )}
            </>
          )}
        </Container>
      </StyledOffCanvasBody>
    </Offcanvas>
  );
};

export default CustomerReminder;
